/* Aesha preview: small global behaviours (size chart units, cart size swap) */
(function () {
  // Size chart: inches / cm toggle
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.aesha-unit');
    if (!btn) return;
    var wrap = btn.closest('.aesha-size-chart');
    var unit = btn.dataset.unit;
    wrap.querySelectorAll('.aesha-unit').forEach(function (b) {
      var on = b.dataset.unit === unit;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    wrap.querySelectorAll('.aesha-size-table').forEach(function (t) { t.hidden = t.dataset.unit !== unit; });
  });

  // Cart: swap size in one step (remove line, add new size, reload cart)
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('.aesha-size-swap');
    if (!sel) return;
    var routes = (window.theme && window.theme.routes) || {};
    var changeUrl = (routes.cart_change_url || '/cart/change') + '.js';
    var addUrl = (routes.cart_add_url || '/cart/add') + '.js';
    var cartUrl = routes.cart_url || '/cart';
    var key = sel.dataset.lineKey;
    var qty = parseInt(sel.dataset.qty, 10) || 1;
    var id = parseInt(sel.value, 10);
    sel.disabled = true;
    var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
    // Add the new size first, so nothing is lost if it fails; then remove the old line.
    fetch(addUrl, { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id: id, quantity: qty }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return fetch(changeUrl, { method: 'POST', headers: json, body: JSON.stringify({ id: key, quantity: 0 }) }); })
      .then(function () { window.location.href = cartUrl; })
      .catch(function () { sel.disabled = false; window.location.reload(); });
  });
})();
